<template>
  <b-card no-body>

    <b-card-header class="pb-50">
      <h5>機台群組排單行事曆</h5>
      <!-- <div>
          <button-copy-url
            tip="複製目前人員行事曆網址"
            @click="CopyButtonClick"
          />
      </div> -->
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="4" class="mb-md-0 mb-2">
          <label>機台群組</label>
          <v-select
            v-model="selectManager.selectedComponent.machineGroup.selected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            class="w-100"
            :options="selectManager.selectedComponent.machineGroup.options"
            @input="selectManager.selectedComponent.machineGroup.selectedEvent"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
import store from '@/store'
import pageJs from '../../js'
import { reactive, getCurrentInstance, ref, onMounted, computed, watch, watchEffect } from '@vue/composition-api'
import tools from '@/sag-core/tools'
import ButtonCopyUrl from '../ButtonCopyUrl.vue'
export default {
  name: "query-drop-down",
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    ButtonCopyUrl
  },
  setup(props, { emit }){

    const selectManager = reactive({
      originData: [],
      query: {},
      queryExecute: (query)=>{
        let keys = Object.keys(selectManager.query)
        
        let fidx = keys.indexOf(query)
        if(fidx >= 0)
          keys.splice(fidx, 1)

        const filterData = selectManager.originData.filter(e => {
          for(let i = 0; i < keys.length; i++){
            if(e[selectManager.query[keys[i]].key] !== selectManager.query[keys[i]].value){
              return false
            }
          }
          return true
        })
        return filterData
      },
      selectedComponent: {
        machineGroup: {
          options: [],
          selected: null,
          readonly: false,
          dump: function(){
              let nd = []
              let filterData = selectManager.queryExecute('machineGroup')
              for(let i = 0; i < filterData.length; i++){
                if(!nd.find(e=>e.value?.trim() === filterData[i]['MachineGroupNo']?.trim())){
                  nd.push({
                    label: filterData[i]['MachineGroupNo'] + ' ' + filterData[i]['MachineGroupName'],
                    value: filterData[i]['MachineGroupNo']
                  })
                }
              }
              tools.arrEx.clear(this.options)
              tools.arrEx.fill(this.options, nd)
          },
          selectedEvent: function(data){
            if(data){
              
              selectManager.query['machineGroup'] = {
                key: 'MachineGroupNo',
                value: data.value
              }
            }
            else{
              delete selectManager.query['machineGroup']
            }
            refresh()

            if(data){
              store.commit(`${pageJs.page.pageInfo.serviceName}/SET_DATAINTERVAL_MachineGroupNo`, data)
              emit('refCalendar')
            }
          }
        },
      }
    })

    const refresh = ()=>{
      let keys = Object.keys(selectManager.selectedComponent)
      for(let i = 0; i < keys.length; i++){
        selectManager.selectedComponent[keys[i]].dump()
      }
    }

    const initialization = ()=>{
      pageJs.api.apiGetCMSMX_GROUP().then(data=>{
        tools.arrEx.clear(selectManager.originData)
        tools.arrEx.fill(selectManager.originData, data)
        refresh()
      })
    }

    initialization()

    // const $bvToast = getCurrentInstance().proxy.$bvToast
    // const CopyButtonClick = ()=>{
    //   if(selectManager.selectedComponent.machine.selected){
    //     $bvToast.toast('複製成功', {
    //       title: '剪貼簿複製',
    //       variant: 'success'
    //     })

    //     let UrlData = {
    //       MachineGroupNo: selectManager.selectedComponent.machine.selected.value,
    //       Date: '2022-11-11',
    //     }
    //     tools.clipboardCopy(tools.web.url('APS/APSKANUI02/' + tools.base64.encode(UrlData)))
    //   }
    //   else{
    //     $bvToast.toast('複製失敗，尚未選擇機台', {
    //       title: '剪貼簿複製',
    //       variant: 'danger'
    //     })
    //   }
    // }

    // onMounted(()=>{
    //   if(pageJs.page?.route?.params?.data ?? null != null){
    //       let obj = tools.base64.decode(pageJs.page.route.params.data)
    //       let MachineGroupNo = obj?.MachineGroupNo ?? singleProps.MachineGroupNo
          
    //       let tar = selectManager.selectedComponent.machine
    //       tat.selected = tar.optoins.find(e=>e.value === MachineGroupNo)
    //   }
    // })
    
    return {
      selectManager,
      // CopyButtonClick
    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.card-header {
  align-items: end;
}
.button-copy-url {
  text-align: right;
}
</style>
